// @vendor
const React = require('react');
const PropTypes = require('prop-types');
import classNames from 'classnames';
// @utilities
const { i18n: { formatText } } = require('core/i18n');
// @components
import TextToggle from 'components/commons/textToggle/textToggle';
const Flag = require('components/broker/commons/flag/flag');
// @tagging
import { EVENT_ESP_ONLY, EVENT_CARD_CONTROL } from 'utilities/tagging';
// @constants
const { getTranslatedCountry } = require('constants/countries');

class OriginCountryListItem extends React.Component {
    render() {
        const { isEnabled, onClickOriginCountryZone, originCountry, disabled } = this.props;
        const containerClass = classNames('container--actions', {
            'enabled': isEnabled,
            'disabled': !isEnabled
        });
        return (
            <div className={containerClass}>
                <div className="dropdown-countries-container row">
                    <div className="dropdown-countries-container__label-not-selectable col-xs-11" >
                        <div className="ok-collapsing-toggler">
                            <Flag className="flag-image" countryCode={originCountry} />
                        </div>
                        <span className="countries-info">
                            <span className="country-name">
                                {`${formatText('cardsConfig-zoneOriginCountry')}${getTranslatedCountry(originCountry)}`}
                            </span>
                            <span className="enable-info"></span>
                        </span>
                    </div>

                    <div
                        className="dropdown-countries-container__toggle col-xs-1"
                        onClick={!disabled && onClickOriginCountryZone}
                      >
                        <TextToggle
                            checked={isEnabled}
                            onClick={!disabled && onClickOriginCountryZone}
                            eventCategory={EVENT_CARD_CONTROL}
                            eventTag={EVENT_ESP_ONLY}
                            textCheck='ON'
                            textUncheck='OFF'
                            isCardControlSection
                        />
                    </div>
                </div>
            </div>
        )

    }
}

OriginCountryListItem.propTypes = {
    nameLiteral: PropTypes.string.isRequired,
    isEnabled: PropTypes.bool.isRequired,
    onClickOriginCountryZone: PropTypes.func.isRequired,
    originCountry: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired,
};


export default OriginCountryListItem;
